// removed by extract-text-webpack-plugin
module.exports = {"container":"Confirmation--container--33bCSXrM","actions":"Confirmation--actions--2JRtwQbS","state":"Confirmation--state--3DYbmEXw","national":"Confirmation--national--3CU-utMJ","table":"Confirmation--table--29LwTfV2","button":"Confirmation--button--20wcfR10"};


//////////////////
// WEBPACK FOOTER
// ./src/App/events/Views/Detail/Confirmation/Confirmation.css
// module id = 1368
// module chunks = 2